import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { I18nService } from '../../service/i18n.service';

@Component({
  selector: 'app-pagina404',
  standalone: true,
  imports: [RouterLink, ButtonModule, TranslateModule],
  templateUrl: './pagina404.component.html',
  styleUrl: './pagina404.component.scss',
})
export class Pagina404Component {
  public translate = inject(TranslateService);
  private i18nService = inject(I18nService);
}
